
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Breadcrumb, } from 'components';
import{addVisitLog, history} from 'libs';
import { Input, Card, DatePicker, Button, Select} from 'antd';
import Table from './Table';
import Form from './Form';
import store from './store';
import 'moment/locale/zh-cn';
import moment from 'moment';
import IFormLog from './Form_log'
import FormWms from './FormWms';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { ReloadOutlined, VerticalAlignBottomOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './index.module.less';

// the hook
import { useTranslation } from 'react-i18next';
import SearchForm, {SearchFormItem} from "../../../components/SearchForm";


export default observer(function () {
  const { t } = useTranslation();
  const [searchType,setSearchType] = useState(false);
  useEffect(() => {
    resetSearch();
  }, [])

  const handleExport = ()=>{
    store.onExport(false);
  }
  const handleExportDetail = ()=>{
    store.onExport(true);
  }
  const onExportCert = ()=>{
    store.onExport('cert');
  }
  const handleSearch = ()=>{
    store.page = 1;
    store.pageSize = localStorage.getItem('orderPageSize') || 10;
    store.pageTotal = 0;
    store.fetchRecords()
  }
  const resetSearch = ()=>{
    store.page = 1;
    store.pageSize = localStorage.getItem('orderPageSize') || 10;
    store.pageTotal = 0;
    store.catalog = null;
    store.brandName = null;
    store.goodsName = null;
    store.factoryCode = null;
    store.projectNo = null;
    store.applyUserName = null;
    store.purchaseNo = null;
    store.deviceSerialNo = null;
    store.hospitalName = null;
    store.centerNo = null;
    store.name = null;
    store.phone = null;
    store.address = null;
    store.createTime = null;
    store.orderSn = null;
    store.fetchRecords()
  }


  const { RangePicker } = DatePicker;
  const { Option } = Select;


  return (
    // <React.Fragment>
      // <Table/>
      // {store.formVisible && <Form/>}
    // </React.Fragment>
     <React.Fragment>
     <div className={[styles.cart, 'rest-nav1'].join(" ")}>

       <div className={styles.listTitle}>
         <span className={styles.title} style={{paddingLeft:'15px'}}>{t('我的订单')}</span>
       </div>

       <SearchForm 
          isExport={true} 
          loading={store.fetching}
          exportCertLoading={store.exportCertLoading} 
          isExportDetail={true} 
          onFinish={handleSearch} 
          onReset={resetSearch} 
          onExport={handleExport} 
          onExportDetail={handleExportDetail} 
          onExportCert={onExportCert} >
       <SearchFormItem title='PO号' name='purchaseNo' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.purchaseNo} onChange={v => store.purchaseNo = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='品牌' name='brandName' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.brandName} onChange={v => store.brandName = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='产品名称' name='goodsName' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.goodsName} onChange={v => store.goodsName = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='货号' name='factoryCode' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.factoryCode} onChange={v => store.factoryCode = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem span={8} title='订单行类型'>
            <Select allowClear placeholder="请选择" value={store.catalog} onChange={v => store.catalog = v}>
                <Select.Option value="Sale">销售</Select.Option>
                <Select.Option value="Rent">租赁</Select.Option>
                <Select.Option value="Store">仓储</Select.Option>
                <Select.Option value="Transfer">转运</Select.Option>
                <Select.Option value="Testing">计量</Select.Option>
              </Select>
          </SearchFormItem>
         <SearchFormItem title='申请人' name='applyUserName' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.applyUserName} onChange={v => store.applyUserName = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='项目号' name='projectNo' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.projectNo} onChange={v => store.projectNo = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='发票抬头' name='invoiceTitle' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.invoiceTitle} onChange={v => store.invoiceTitle = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='序列号' name='deviceSerialNo' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.deviceSerialNo} onChange={v => store.deviceSerialNo = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='医院名称' name='hospitalName' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.hospitalName} onChange={v => store.hospitalName = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='中心号' name='centerNo' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.centerNo} onChange={v => store.centerNo = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='联系人' name='name' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.name} onChange={v => store.name = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='手机号' name='phone' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.phone} onChange={v => store.phone = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='地址' name='address' span={8}>
           <Input autoComplete="off" placeholder="请输入" value={store.address} onChange={v => store.address = v.target.value || null} allowClear/>
         </SearchFormItem>
         <SearchFormItem title='下单日期' name='createTime' span={8}>
            <RangePicker allowClear format="YYYY-MM-DD" value={store.createTime} locale={locale} onChange={e => store.createTime = e}/>
         </SearchFormItem>
         <SearchFormItem title='销售订单号' name='orderSn' span={8}>
         <Input autoComplete="off" placeholder="请输入" value={store.orderSn} onChange={v => store.orderSn = v.target.value || null} allowClear/>
         </SearchFormItem>
       </SearchForm>

       <div className="mainBox">
       <Table/>
        </div>
       {store.formVisible && <Form/>}
       {store.formWmsVisible && <FormWms />}
       {store.formLogVisible && <IFormLog />}
     </div>

   </React.Fragment>
  )
})